const NEWS_STORAGE_KEY = "karda-news-viewed";

type NewsStorage = {
  viewedNewsIds: string[];
  lastChecked: number;
};

const defaultStorage: NewsStorage = {
  viewedNewsIds: [],
  lastChecked: 0,
};

const isBrowser = typeof window !== "undefined";

const readStorage = (): NewsStorage => {
  if (!isBrowser) {
    return defaultStorage;
  }

  try {
    const storedValue = window.localStorage.getItem(NEWS_STORAGE_KEY);
    if (!storedValue) {
      return defaultStorage;
    }

    const parsed = JSON.parse(storedValue) as Partial<NewsStorage>;
    return {
      viewedNewsIds: Array.isArray(parsed.viewedNewsIds)
        ? parsed.viewedNewsIds
        : [],
      lastChecked:
        typeof parsed.lastChecked === "number" ? parsed.lastChecked : 0,
    };
  } catch (error) {
    console.error("Failed to parse news storage", error);
    return defaultStorage;
  }
};

const writeStorage = (data: NewsStorage) => {
  if (!isBrowser) {
    return;
  }

  try {
    window.localStorage.setItem(NEWS_STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Failed to write news storage", error);
  }
};

export const getViewedNewsIds = (): string[] => {
  const { viewedNewsIds } = readStorage();
  return viewedNewsIds;
};

export const markNewsAsViewed = (newsIds: string[]) => {
  const filteredIds = (newsIds || []).filter(Boolean);

  if (filteredIds.length === 0) {
    return;
  }

  const existingIds = getViewedNewsIds();
  const mergedIds = Array.from(new Set([...existingIds, ...filteredIds]));

  writeStorage({
    viewedNewsIds: mergedIds,
    lastChecked: Date.now(),
  });
};

export const isNewsViewed = (newsId: string): boolean => {
  if (!newsId) return false;
  const viewedIds = getViewedNewsIds();
  return viewedIds.includes(newsId);
};
